import React, { Component } from "react";
import styles from "./css/NewsletterSubCompo.module.css";

export class NewsletterSubCompo extends Component {
  render() {
    return (
      <div className={styles.newsletterSubCompo}>
        <div className={styles.newsletterSubCompoInner}>
          <div>
            <div className={styles.topHeading}>
              <div className={styles.headingCont}>
                <h2>Subscribe to Newsletter</h2>
              </div>
            </div>
            <div className={styles.subscriptionField}>
              <div className={styles.subscriptionFieldInner}>
                <div className={styles.inputField}>
                  <input type="text" placeholder="Enter your email" />
                </div>
                <div className={styles.subButton}>
                  <button>Subscribe</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default NewsletterSubCompo;
